<template>
  <div>
    <Multiselect
      class="multiselect-custom-input"
      v-model="value"
      :close-on-select="true"
      :options="options"
      :loading="loading"
    />
  </div>
</template>

<script>
import Multiselect from '@vueform/multiselect';

export default {
  props: ['modelValue'],
  emits: ['onChange'],
  components: {
    Multiselect
  },
  watch: {
    modelValue() {
      this.value = this.modelValue;
    },
    value() {
      this.$emit('onChange', this.value);
    }
  },
  mounted() {
    this.value = `${this.modelValue}`;
    this.getOptions();
  },
  methods: {
    getOptions() {
      this.options = [
        { value: 'en', label: 'English' },
        { value: 'es', label: 'Español' },
        { value: 'pt', label: 'Português' }
      ];
    }
  },
  data() {
    return {
      loading: false,
      value: null,
      options: []
    };
  }
};
</script>

<style scoped>
.multiselect-custom-input {
  border: 1px solid #e2e5e8 !important;
  border-radius: 0.75rem !important;
}
</style>

<style src="@vueform/multiselect/themes/default.css"></style>
